import { Stack } from 'expo-router';
import * as React from 'react';
import { View } from 'react-native';

import { OldTownRoutePreview } from '@/components/routes/old-town-route-preview';

export default function RoutePreviewScreen() {
  return (
    <View className="flex-1 bg-[#1A1A1A]">
      <Stack.Screen options={{ headerShown: false, title: 'Old Town Canal Run' }} />
      <OldTownRoutePreview />
    </View>
  );
}
